import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { useParams } from "react-router"
import { useStore } from "../stores/StoreProvider.js"
import { GalleryView } from "../components/GalleryView.js"
import { getTelegramWebApp } from "../lib/telegram.js"

export const GalleryPage = observer(function GalleryPage() {
  const { slug } = useParams<{ slug: string }>()
  const { galleryStore, themeStore } = useStore()

  useEffect(() => {
    if (slug) {
      void galleryStore.fetchGallery(slug)
    }
  }, [slug, galleryStore])

  // Apply gallery theme when loaded
  useEffect(() => {
    if (galleryStore.detailState.status === "loaded") {
      const { gallery } = galleryStore.detailState
      try {
        const config = JSON.parse(gallery.themeConfig ?? "{}")
        themeStore.applyGalleryTheme(config.theme ?? {}, config.layout ?? {})
      } catch {
        themeStore.applyGalleryTheme({}, {})
      }
    }
    return () => themeStore.resetTheme()
  }, [galleryStore.detailState.status, themeStore])

  // Telegram back button
  useEffect(() => {
    const webapp = getTelegramWebApp()
    if (!webapp) return
    webapp.BackButton.show()
    const goBack = () => {
      window.history.back()
    }
    webapp.BackButton.onClick(goBack)
    return () => {
      webapp.BackButton.offClick(goBack)
      webapp.BackButton.hide()
    }
  }, [])

  return (
    <div className="min-h-screen bg-tg-bg">
      <GalleryView />
    </div>
  )
})
